export type LanguageType = "en" | "de" | "et" | "lt" | "ru" | "lv";

const languageMap = {
  de: {
    de: "Deutsch",
    en: "English",
  },
  ee: {
    et: "Estonian",
    ru: "Russian",
    en: "English",
  },
  lt: {
    lt: "Lietuvių",
    en: "English",
  },
  lv: {
    lv: "Latviski",
    en: "English",
  },
} as const;
const fallback = { en: "English" } as const;

interface IAppConfig {
  certificateRequesterBaseUrl: string;

  country: "de" | "ee" | "lt" | "lv";

  environment: string;

  authorityBaseUrl: string;

  apiBaseUrl: string;

  mypagesUrl: string;

  authUiUrl: string;

  languages: {
    [key in LanguageType]?: string;
  };

  instrumentationKey: string;
}

const appConfig: IAppConfig = {
  certificateRequesterBaseUrl: process.env
    .REACT_APP_CERTIFICATE_REQUESTER_URL as string,

  country: process.env.REACT_APP_COUNTRY as "de" | "ee" | "lt" | "lv",

  environment: process.env.REACT_APP_ENVIRONMENT as string,

  authorityBaseUrl: process.env.REACT_APP_AUTHORITY_BASE_URL as string,

  apiBaseUrl: process.env.REACT_APP_BASE_API_URL as string,

  instrumentationKey: process.env.REACT_APP_INSTRUMENTATION_KEY as string,

  mypagesUrl: process.env.REACT_APP_MYPAGES_URL as string,

  authUiUrl: process.env.REACT_APP_AUTHUI_URL as string,

  languages:
    languageMap[process.env.REACT_APP_COUNTRY as keyof typeof languageMap] ??
    fallback,
};

export default appConfig;
